import { formatNumber } from '@/helpers/format-number'

export default {
  computed: {
    updateVehicleDriverFields() {
      return [
        {
          type: 'multiselect-input',
          name: 'vehicle',
          key: 'vehicle',
          label: this.$t('fleetTaskInstant.field.licensePlate'),
          placeholder: this.$t('fleetTaskInstant.placeholder.licensePlate'),
          trackBy: 'id',
          displayedBy: 'license_plate',
          groupLabel: 'type',
          groupValues: 'data',
          required: true,
          options: [
            {
              type: {
                key: 'vehicle-currently',
                value: this.$t('fleetTaskInstant.category.currentVehicle'),
              },
            },
            {
              type: {
                key: 'vehicle-available',
                value: this.$t('fleetTaskInstant.category.availableVehicle'),
                tooltip: this.$t('fleetTaskInstant.tooltip.availableVehicle'),
              },
            },
          ],
          customValue: (initialValue, value) => {
            if (initialValue?.id == value?.id) {
              return `
                  <div class="__option-content">
                  <div class="__license-plate">
                    ${value?.license_plate}
                  </div>
                </div>
              `
            } else {
              return `
                <div class="__option-content">
                  <div class="__distance">
                    <div class="mc-icon icon-outline_pin"></div>
                    <div>${this.formatDistance(value.distance)}</div>
                  </div>
                  <span class="__divider"></span>
                  <div class="__license-plate">
                    ${value.license_plate}
                  </div>
                  <span class="__divider"></span>
                  <div class="__vehicle-type">
                    ${value.vehicle_type?.type}
                  </div>
                </div>
              `
            }
          }
        },
        {
          type: 'multiselect-input',
          name: 'driver',
          key: 'driver',
          label: this.$t('global.field.driver'),
          placeholder: this.$t('fleetTaskInstant.placeholder.driver'),
          trackBy: 'id',
          displayedBy: 'name',
          groupLabel: 'type',
          groupValues: 'data',
          options: [
            {
              type: {
                key: 'driver-currently',
                value: this.$t('fleetTaskInstant.category.currentDriver'),
              },
            },
            {
              type: {
                key: 'driver-available',
                value: this.$t('fleetTaskInstant.category.availableDriver'),
                tooltip: this.$t('fleetTaskInstant.tooltip.availableDriver'),
              },
            },
          ],
          customLabel: ({ name, phone_no }) => {
            return `${name}${phone_no ? ' (' + phone_no + ')' : ''}`
          },
          customValue: (_, value) => {
            return `
              <div class="__option-content">
                <div class="__driver-info">
                  ${value.name}${value?.phone_no ? ' (' + value.phone_no + ')' : ''}
                </div>
              </div>
            `
          }
        },
        {
          type: 'textarea',
          name: 'reason',
          label: this.$t('fleetTaskInstant.field.reason'),
          placeholder: this.$t('fleetTaskInstant.placeholder.updateVehicleDriver'),
          class: 'col-12 __textarea-input',
          validation: 'required:trim',
          help: 'true',
        },
      ]
    },
  },
  methods: {
    formatDistance(value) {
      let distance = value
      if (distance >= 1000) {
        return `${formatNumber(distance / 1000)} km`
      }
      return '< 1 km'
    },
  }
}